import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModal {

    @Input() title = '';
    @Input() content = '';
    @Input() buttonText = 'Chiudi';

    constructor(
        public activeModal: NgbActiveModal,
    ) {
    }
}